import React, { Component } from "react";
import { Row, Col, Card, CardBody, CardTitle, Button, Label, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip } from "reactstrap";
import { Link, useHistory, Redirect } from "react-router-dom";
import { isEmpty, size } from "lodash";
import { showToast } from '../../UI/ui-toast'

import DeleteModal from "../../../components/Common/DeleteModal";
import moment from "moment";
import { get_user_permissions } from "../../../helpers/custom_helper"

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import ToolkitProvider, {
    Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { get_all_payment_plans, delete_payment_plan } from '../api/paymentPlanApi';
import { get_all_project_payment_plans } from '../../Projects/api/projectApi'

import default_avatar from "../../../assets/images/avatar_01.png";

var paymentPlanEdit, paymentPlanView, paymentPlanCreate, paymentPlanDelete, paymentPlanLog;

class ListPaymentPlans extends Component {
    constructor(props) {
        super(props);
        this.node = React.createRef();
        this.state = {
            page: 1,
            sizePerPage: 10,
            listData: [],
            listdata: "",
            log_data: '',
            viewmodal: false,
            modal: false,
            isOpen: false,
            selectDate: false,
            deleteModal: false,
            recordDeleteID: null,
            redirect: null,
            listDataLoded: 0,
            dataLength: 0,
        };
        this.handleRecordClick = this.handleRecordClick.bind(this);
        this.handleAddNominee = this.handleAddNominee.bind(this);
        this.handleListNominee = this.handleListNominee.bind(this);
        this.toggle = this.toggle.bind(this);
        this.handleRecordClicks = this.handleRecordClicks.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
        this.onClickActivityLog = this.onClickActivityLog.bind(this);
    }
    componentDidMount() {
        this.setState({ listDataLoded: 0 });
        paymentPlanEdit = get_user_permissions('payment-plan-edit');
        paymentPlanView = get_user_permissions('payment-plan-view');
        paymentPlanCreate = get_user_permissions('payment-plan-create');
        paymentPlanDelete = get_user_permissions('payment-plan-delete');
        paymentPlanLog = get_user_permissions('payment-plan-logs-view');
        window.localStorage.removeItem('current_payment_plan')
        if (localStorage.getItem('project_id_against_plan') != null) {
            Promise.all([get_all_project_payment_plans(localStorage.getItem('project_id_against_plan'))]).then((values) => {
                console.log(values[0]);
                var nLength = 0;
                if (values[0].length == undefined) {
                    nLength = 0;
                }
                else {
                    nLength = values[0].length;
                }
                this.setState({ dataLength: nLength });
                this.setState({ listData: values[0] });
                this.setState({ listDataLoded: 1 });

            });
            localStorage.removeItem('project_id_against_plan')
        } else {
            Promise.all([get_all_payment_plans()]).then((values) => {
                console.log(values[0]);
                this.setState({ listData: values[0] });
                this.setState({ listDataLoded: 1 });
                this.setState({ dataLength: values[0].length });
            });
        }

    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { listData } = this.props;
        if (!isEmpty(listData) && size(prevProps.listData) !== size(listData)) {
            this.setState({ listData: {}, isEdit: false });
        }
    }
    onPaginationPageChange = page => {
        if (
            this.node &&
            this.node.current &&
            this.node.current.props &&
            this.node.current.props.pagination &&
            this.node.current.props.pagination.options
        ) {
            this.node.current.props.pagination.options.onPageChange(page);
        }
    };
    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal,
        }));
    }
    toggleDeleteModal = () => {
        this.setState(prevState => ({
            deleteModal: !prevState.deleteModal,
        }));
    };
    onClickDelete = listdata => {
        this.setState({ listdata: listdata });
        this.setState({ deleteModal: true });
    };
    onClickActivityLog = arg => {
        const listdata = arg;
        window.localStorage.setItem("current_payment_plan", listdata.id);
        this.setState({ redirect: "/payment-plan/log" });
    }
    handleDeletejob = () => {
        const { listdata } = this.state;
        if (listdata.id !== undefined) {
            console.log(this.state.recordDeleteID);
            Promise.all([delete_payment_plan(this.state.recordDeleteID)])
                .then((delValues) => {
                    showToast("Success", "The payment plan has been deleted successfully.", "success");
                    Promise.all([get_all_payment_plans()]).then((values) => {
                        console.log(values[0]);
                        this.setState({ listData: values[0] });
                    });
                }).catch((error) => {
                    showToast("Failed", "Payment Plan Not Deleted!", "error");
                });
            this.setState({ deleteModal: false });
        }
    };
    onClickView = arg => {
        const listdata = arg;
        window.localStorage.setItem("current_payment_plan", listdata.id);
        this.setState({ redirect: "/payment-plan/view" });
    }
    handleRecordClicks = () => {
        this.setState({ listdata: "", isEdit: false });
        this.toggle();
    };

    handleRecordClick = arg => {
        const listdata = arg;
        window.localStorage.setItem("current_payment_plan", listdata.id);
        this.setState({ redirect: "/payment-plan/edit" });
    };
    handleAddNominee = arg => {
        const listdata = arg;
        window.localStorage.setItem("current_customer_id", listdata.id);
        this.setState({ redirect: "/customer/nominee/add" });
    };
    handleListNominee = arg => {
        const listdata = arg;
        window.localStorage.setItem("current_customer_id", listdata.id);
        this.setState({ redirect: "/customer/nominees/list" });
    };
    render() {

        const { isEdit, deleteModal } = this.state;

        const listdata = this.state.listdata;

        if (this.state.redirect) {
            return <Redirect to={this.state.redirect} />
        }

        const columns = [
            // {
            //     dataField: "id",
            //     text: "Id",
            //     sort: true,
            // },
            {
                dataField: "project_name",
                text: "Project Name",
                sort: true,
            },
            {
                dataField: "name",
                text: "Payment Plan",
                sort: true,
            },
            {
                dataField: "size_name",
                text: "Size",
                sort: true,
            },
            // {
            //     dataField: "status",
            //     text: "Status",
            //     sort: true,
            //     formatter: (cellContent, listdata) => {
            //         return (listdata.status == 1 ? 'Yes' : 'No');
            //     },
            // },
            {
                dataField: "updated_name",
                text: "Updated By",
                sort: true,
            },
            /*{
                dataField: "created_at",
                text: "Created at",
                sort: true,
                formatter: (cellContent, listdata) => (
                    <>
                        {moment(listdata.created_at).format('DD/MM/YYYY h:mma')}
                    </>

                ),

            },*/
            {
                dataField: "updated_at",
                text: "Updated At",
                sort: true,
                formatter: (cellContent, listdata) => (
                    <>
                        {moment(listdata.updated_at).format('DD/MM/YYYY h:mma')}
                    </>

                ),
            },
            {
                dataField: "action",
                isDummyField: true,
                text: "Action",
                formatter: (cellContent, listdata) => (
                    <>
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            {paymentPlanView ? <>
                                {paymentPlanLog ? <>
                                    <li>
                                        <Link
                                            to="#"
                                            className="btn btn-sm btn-soft-primary"
                                            onClick={() => this.onClickActivityLog(listdata)}
                                        >
                                            <i className="mdi mdi-file-document-outline" id="logtooltip" />
                                            <UncontrolledTooltip placement="top" target="logtooltip">
                                                Activity Log
                                            </UncontrolledTooltip>
                                        </Link>
                                    </li>
                                </> : <></>}
                            </> : <></>}
                            {paymentPlanView ? <>
                                <li>
                                    <Link
                                        to="#"
                                        className="btn btn-sm btn-soft-primary"
                                        onClick={() => this.onClickView(listdata)}
                                    >
                                        <i className="mdi mdi-eye-outline" id="viewtooltip" />
                                        <UncontrolledTooltip placement="top" target="viewtooltip">
                                            View
                                        </UncontrolledTooltip>
                                    </Link>
                                </li>
                            </> : <></>}
                            {paymentPlanEdit ? <>
                                <li>
                                    <Link
                                        to="#"
                                        className="btn btn-sm btn-soft-info"
                                        onClick={() => this.handleRecordClick(listdata)}
                                    >
                                        <i className="mdi mdi-pencil-outline" id="edittooltip" />
                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                            Edit
                                        </UncontrolledTooltip>
                                    </Link>
                                </li>
                            </> : <></>}
                            {paymentPlanDelete ? <>
                                <li>
                                    <Link
                                        to="#"
                                        className="btn btn-sm btn-soft-danger"
                                        onClick={() => this.onClickDelete(listdata)}
                                    >
                                        <i className="mdi mdi-delete-outline" id="deletetooltip" />
                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                            Delete
                                        </UncontrolledTooltip>
                                    </Link>
                                </li>
                            </> : <></>}
                        </ul>
                    </>
                ),
            },
        ];

        const defaultSorted = [
            {
                dataField: "id",
                order: "asc",
            },
        ];

        const pageOptions = {
            sizePerPage: 10,
            // totalSize: productsData.length, // replace later with size(customers),
            custom: true,
        };

        // Select All Button operation
        const selectRow = {
            mode: "checkbox",
        };

        const { SearchBar } = Search;

        //meta title
        document.title = "List Payment Plans";
        const rowEvents = {
            onClick: (e, row, rowIndex) => {
                this.setState({ recordDeleteID: row.id });
            }
        }
        return (
            <React.Fragment>
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={this.handleDeletejob}
                    record={`payment_plan`}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />
                <div className="page-content">
                    <div className="container-fluid">
                        <Breadcrumbs title="Payment Plans" breadcrumbItem="List Payment Plans" />

                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        {this.state.dataLength == 0 && this.state.listDataLoded == 1 ? <>
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1">Payment Plans not found.</h5>
                                                {paymentPlanCreate ? <>
                                                    <div className="flex-shrink-0">
                                                        <Link to="/payment-plan/add" className="btn btn-primary me-1">Add New Payment Plan</Link>
                                                    </div>
                                                </> : <></>}
                                            </div>
                                        </> : <>
                                            <CardBody className="border-bottom">
                                                <div className="d-flex align-items-center">
                                                    <h5 className="mb-0 card-title flex-grow-1">List Payment Plans</h5>
                                                    {paymentPlanCreate ? <>
                                                        <div className="flex-shrink-0">
                                                            <Link to="/payment-plan/add" className="btn btn-primary me-1">Add New Payment Plan</Link>
                                                        </div>
                                                    </> : <></>}
                                                </div>
                                            </CardBody>
                                            <PaginationProvider
                                                pagination={paginationFactory(pageOptions)}
                                                keyField="id"
                                                columns={columns}
                                                data={this.state.listData}
                                            >
                                                {({ paginationProps, paginationTableProps }) => (
                                                    <ToolkitProvider
                                                        keyField="id"
                                                        columns={columns}
                                                        data={this.state.listData}
                                                        search
                                                    >
                                                        {toolkitProps => (
                                                            <React.Fragment>
                                                                <Row className="mb-2">
                                                                    <Col md="4">
                                                                        <div className="search-box me-2 mb-2 d-inline-block">
                                                                            <div className="position-relative">
                                                                                <SearchBar
                                                                                    {...toolkitProps.searchProps}
                                                                                />
                                                                                <i className="bx bx-search-alt search-icon" />
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>

                                                                <Row>
                                                                    <Col xl="12">
                                                                        <div className="table-responsive">
                                                                            <BootstrapTable
                                                                                keyField={"id"}
                                                                                responsive
                                                                                bordered={false}
                                                                                striped={false}
                                                                                defaultSorted={defaultSorted}
                                                                                selectRow={selectRow}
                                                                                rowEvents={rowEvents}
                                                                                classes={
                                                                                    "table align-middle table-nowrap"
                                                                                }
                                                                                headerWrapperClasses={"thead-light"}
                                                                                {...toolkitProps.baseProps}
                                                                                {...paginationTableProps}
                                                                                ref={this.node}
                                                                            />
                                                                            <Modal
                                                                                isOpen={this.state.modal}
                                                                                className={this.props.className}
                                                                            >
                                                                                <ModalHeader toggle={this.toggle} tag="h4">
                                                                                    {!!isEdit ? "Edit Payment Plan" : "Add Payment Plan"}
                                                                                </ModalHeader>
                                                                                <ModalBody>
                                                                                    <Formik
                                                                                        enableReinitialize={true}
                                                                                        initialValues={{
                                                                                            id: (listdata && listdata.id) || '',
                                                                                            name: (listdata && listdata.name) || '',
                                                                                        }}
                                                                                        validationSchema={Yup.object().shape({
                                                                                            id: Yup.string().required("Please Enter Your Id"),
                                                                                            name: Yup.string().required("Please Enter Your Name"),
                                                                                        })}
                                                                                        onSubmit={values => {
                                                                                            /*Promise.all([update_project(values.id, values.name)]).then((response) => {
                                                                                                console.log(response[0]);
                                                                                                Promise.all([get_all_customers()]).then((values) => {
                                                                                                    console.log(values[0]);
                                                                                                    this.setState({ listData: values[0] });
                                                                                                });
                                                                                            });*/
                                                                                            this.toggle();
                                                                                        }}
                                                                                    >
                                                                                        {({ errors, status, touched }) => (
                                                                                            <Form>
                                                                                                <Row>
                                                                                                    <Col className="col-12">
                                                                                                        <div className="mb-3">
                                                                                                            <Label className="form-label">
                                                                                                                Payment Plan Id
                                                                                                            </Label>
                                                                                                            <Field
                                                                                                                name="id"
                                                                                                                disabled
                                                                                                                type="text"
                                                                                                                className={
                                                                                                                    "form-control" +
                                                                                                                    (errors.id &&
                                                                                                                        touched.id
                                                                                                                        ? " is-invalid"
                                                                                                                        : "")
                                                                                                                }
                                                                                                            />
                                                                                                            <ErrorMessage
                                                                                                                name="id"
                                                                                                                component="div"
                                                                                                                className="invalid-feedback"
                                                                                                            />
                                                                                                        </div>
                                                                                                        <div className="mb-3">
                                                                                                            <Label className="form-label">
                                                                                                                Name
                                                                                                            </Label>
                                                                                                            <Field
                                                                                                                name="name"
                                                                                                                type="text"
                                                                                                                className={
                                                                                                                    "form-control" +
                                                                                                                    (errors.name &&
                                                                                                                        touched.name
                                                                                                                        ? " is-invalid"
                                                                                                                        : "")
                                                                                                                }
                                                                                                            />
                                                                                                            <ErrorMessage
                                                                                                                name="name"
                                                                                                                component="div"
                                                                                                                className="invalid-feedback"
                                                                                                            />
                                                                                                        </div>
                                                                                                    </Col>
                                                                                                </Row>
                                                                                                <Row>
                                                                                                    <Col>
                                                                                                        <div className="text-end">
                                                                                                            <button
                                                                                                                type="submit"
                                                                                                                className="btn btn-primary save-user"
                                                                                                            >
                                                                                                                Save
                                                                                                            </button>
                                                                                                        </div>
                                                                                                    </Col>
                                                                                                </Row>
                                                                                            </Form>
                                                                                        )}
                                                                                    </Formik>
                                                                                </ModalBody>
                                                                            </Modal>
                                                                        </div>
                                                                    </Col>
                                                                </Row>

                                                                <Row className="align-items-md-center mt-30">
                                                                    <Col className="inner-custom-pagination d-flex">
                                                                        <div className="d-inline">Results Per Page&nbsp;&nbsp;
                                                                            <SizePerPageDropdownStandalone
                                                                                {...paginationProps}
                                                                            />
                                                                        </div>
                                                                        <div className="text-md-right ms-auto">
                                                                            <PaginationListStandalone
                                                                                {...paginationProps}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </React.Fragment>
                                                        )}
                                                    </ToolkitProvider>
                                                )}
                                            </PaginationProvider>
                                        </>}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export default ListPaymentPlans;
